export default {
  redeemCode: {
    title: 'แลกรหัส',
    description: 'กรอกรหัสแลกของคุณด้านล่างเพื่อรับรางวัล',
    enterTip: 'ป้อนรหัสแลกของรางวัลเพื่อรับรางวัล',
    label: 'รหัสแลก',
    placeholder: 'กรอกรหัสแลก',
    submit: 'แลก',
    redeemBtn: 'แลกรางวัล',
    submitting: 'กำลังแลก...',
    success: 'แลกรหัสสำเร็จ!',
    redeemSuccess: 'แลกรหัสสำเร็จ!',
    failed: 'แลกรหัสไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    redeemFailed: 'แลกรหัสไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'
  }
};
